<script setup lang="ts">
/**
 * What a tab about the chosen element says when none is: how to choose one,
 * and the way to the list or to adding one, rather than an empty panel.
 */
import { useI18n } from 'vue-i18n'

defineProps<{
  /** Whether the layer has elements to choose from. */
  elements: boolean
}>()

const emit = defineEmits<{ layers: []; add: [] }>()

const { t } = useI18n()
</script>

<template>
  <div class="nothing">
    <p class="nothing__title">{{ t('inspector.layer.nothingTitle') }}</p>
    <p class="nothing__text">
      {{ elements ? t('inspector.layer.nothingText') : t('inspector.layer.none') }}
    </p>
    <div class="nothing__ops">
      <button v-if="elements" type="button" class="b-btn b-btn--outline" @click="emit('layers')">
        {{ t('inspector.layer.showLayers') }}
      </button>
      <button type="button" class="b-btn b-btn--soft" @click="emit('add')">
        {{ t('inspector.layer.addOne') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.nothing {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-3);
  padding: var(--sp-6) var(--sp-5);
  border: 1px dashed var(--hairline-strong);
  border-radius: var(--radius);
}

.nothing__title {
  margin: 0;
  color: var(--ink);
  font-size: var(--text-sm);
  font-weight: 600;
}

.nothing__text {
  margin: 0;
  color: var(--ink-faint);
  font-size: var(--text-sm);
  line-height: 1.5;
}

.nothing__ops {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3);
  margin-top: var(--sp-2);
}
</style>
